import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import Constants from "../../../../common/SupplierConstants";
import { getTodaysData } from "../../../../common/Validations";

const ErfExtenssionModal = React.forwardRef((props, ref) => {
  const [formInputs, setFormInputs] = useState({
    extensionCount: "E0",
    rentPerDay: "",
    extensionfromDate: "",
    extensiontoDate: "",
    extendedDays: "",
    rentValue: "",
    extensionRemarks: "",
  });

  const [tableData, setTableData] = useState([]);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [parentRowData, setParentRowData] = useState(null);

  // Initialize data from props when modal opens
  // useEffect(() => {
  //   if (props.show) {
  //     setParentRowData(props.data || null);

  //     const existingExtensions = props.data?.extensionItemsdetails || [];
  //     setTableData(existingExtensions);

  //     const getNextDay = (dateStr) => {
  //       if (!dateStr) return "";
  //       const date = new Date(dateStr);
  //       date.setDate(date.getDate() + 1);
  //       return date.toISOString().split("T")[0];
  //     };

  //     const calculateNextExtensionMeta = () => {
  //       if (existingExtensions.length > 0) {
  //         const lastItem = existingExtensions[existingExtensions.length - 1];
  //         const match = lastItem.extensionCount?.match(/E(\d+)/);

  //         return {
  //           count: match ? `E${parseInt(match[1]) + 1}` : "E0",
  //           fromDate: getNextDay(lastItem.extensiontoDate),
  //         };
  //       }
  //       return { count: "E0", fromDate: "" };
  //     };

  //     const { count, fromDate } = calculateNextExtensionMeta();

  //     setFormInputs((prev) => ({
  //       ...prev,
  //       extensionCount: count,
  //       extensionfromDate: fromDate || getTodaysData(),
  //       extensiontoDate: "",
  //       extendedDays: "",
  //       rentValue: "",
  //       rentPerDay: props.data?.pricePerDay || "",
  //     }));
  //   }
  // }, [props.show, props.data]);

  // Initialize data from props when modal opens
useEffect(() => {
  if (props.show) {
    setParentRowData(props.data || null);

    const existingExtensions = props.data?.extensionItemsdetails || [];
    setTableData(existingExtensions);

    const getNextDay = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      date.setDate(date.getDate() + 1);
      return date.toISOString().split("T")[0];
    };

    const calculateNextExtensionMeta = () => {
      if (existingExtensions.length > 0) {
        // If extensions exist, use last extension's to date
        const lastItem = existingExtensions[existingExtensions.length - 1];
        const match = lastItem.extensionCount?.match(/E(\d+)/);

        return {
          count: match ? `E${parseInt(match[1]) + 1}` : "E0",
          fromDate: getNextDay(lastItem.extensiontoDate),
        };
      } else if (props.data?.toDate) {
        // If no extensions but toDate exists in parent row, use it
        return {
          count: "E0",
          fromDate: getNextDay(props.data.toDate),
        };
      }
      return { count: "E0", fromDate: getTodaysData() };
    };

    const { count, fromDate } = calculateNextExtensionMeta();

    setFormInputs((prev) => ({
      ...prev,
      extensionCount: count,
      extensionfromDate: fromDate,
      extensiontoDate: "",
      extendedDays: "",
      rentValue: "",
      rentPerDay: props.data?.rentPerDay || props.data?.pricePerDay || "",
    }));
  }
}, [props.show, props.data]);

  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const updatedInputs = {
      ...formInputs,
      [name]: value,
    };

    // Calculate extended days and rent value when dates are entered
    if (
      name === "extensionfromDate" ||
      name === "extensiontoDate" ||
      name === "rentPerDay"
    ) {
      if (updatedInputs.extensionfromDate && updatedInputs.extensiontoDate) {
        const fromDate = new Date(updatedInputs.extensionfromDate);
        const toDate = new Date(updatedInputs.extensiontoDate);

        // Validate that to date is after from date
        if (toDate >= fromDate) {
          const timeDiff = toDate.getTime() - fromDate.getTime();
          const extendedDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; // +1 to include both start and end days

          if (extendedDays > 0) {
            updatedInputs.extendedDays = extendedDays.toString();

            // Calculate rent value if rent per day is provided
            if (updatedInputs.rentPerDay) {
              const rentValue =
                parseFloat(updatedInputs.rentPerDay) * extendedDays;
              updatedInputs.rentValue = rentValue.toFixed(2);
            }
          }
        } else {
          // Reset if dates are invalid
          updatedInputs.extendedDays = "";
          updatedInputs.rentValue = "";
        }
      }
    }

    // Recalculate rent value when rent per day changes
    if (name === "rentPerDay" && updatedInputs.extendedDays) {
      const extendedDays = parseInt(updatedInputs.extendedDays);
      const rentPerDay = parseFloat(value) || 0;
      updatedInputs.rentValue = (rentPerDay * extendedDays).toFixed(2);
    }

    setFormInputs(updatedInputs);
  };

  /* Add extension to table */
  const addExtensionToTable = () => {
    // Validation
    if (!formInputs.extensionfromDate || !formInputs.extensiontoDate) {
      alert("Please select both From Date and To Date");
      return;
    }

    const fromDate = new Date(formInputs.extensionfromDate);
    const toDate = new Date(formInputs.extensiontoDate);

    if (toDate < fromDate) {
      alert("To Date must be after From Date");
      return;
    }

    if (!formInputs.rentPerDay || parseFloat(formInputs.rentPerDay) <= 0) {
      alert("Please enter a valid Rent Per Day");
      return;
    }

    const newExtension = {
      id: Date.now(), // Unique ID for deletion
      extensionCount: formInputs.extensionCount,
      extensionfromDate: formInputs.extensionfromDate,
      extensiontoDate: formInputs.extensiontoDate,
      extendedDays: formInputs.extendedDays || "0",
      rentPerDay: parseFloat(formInputs.rentPerDay).toFixed(2),
      rentValue: formInputs.rentValue || "0.00",
      extensionRemarks: formInputs.extensionRemarks || "",
      // Include parent data for reference
      parentItemId: parentRowData?.id || "",
      parentItemName: parentRowData?.itemName || "",
    };

    // Add to table
    const updatedTableData = [...tableData, newExtension];
    setTableData(updatedTableData);

    // Calculate next extension count
    const match = formInputs.extensionCount.match(/E(\d+)/);
    if (match) {
      const currentNumber = parseInt(match[1]);
      const nextExtensionCount = `E${currentNumber + 1}`;

      // Reset form for next entry (keep the next extension count and rent per day)
      setFormInputs({
        extensionCount: nextExtensionCount,
        rentPerDay: formInputs.rentPerDay, // Keep rent per day for convenience
        extensionfromDate: "",
        extensiontoDate: "",
        extendedDays: "",
        rentValue: "",
        extensionRemarks: "",
      });
    }
  };

  /* Delete row from table */
  const deleteRow = (id) => {
    const updatedTableData = tableData.filter((item) => item.id !== id);
    setTableData(updatedTableData);

    // Recalculate extension counts if needed
    if (updatedTableData.length > 0) {
      // Sort by extension count
      const sortedData = [...updatedTableData].sort((a, b) => {
        const numA = parseInt(a.extensionCount.substring(1));
        const numB = parseInt(b.extensionCount.substring(1));
        return numA - numB;
      });

      // Update counts sequentially
      const renumberedData = sortedData.map((item, index) => ({
        ...item,
        extensionCount: `E${index}`,
      }));

      setTableData(renumberedData);

      // Update form for next extension
      const nextCount = `E${renumberedData.length}`;
      setFormInputs((prev) => ({
        ...prev,
        extensionCount: nextCount,
      }));
    } else {
      // Reset to E0 if no extensions
      setFormInputs((prev) => ({
        ...prev,
        extensionCount: "E0",
      }));
    }
  };

  /* Cancel */
  const handleCancel = () => {
    props.onHide();
    setFormInputs({
      extensionCount: "E0",
      rentPerDay: parentRowData?.pricePerDay || "",
      extensionfromDate: "",
      extensiontoDate: "",
      extendedDays: "",
      rentValue: "",
      extensionRemarks: "",
    });
    setTableData(props.data?.extensionItemsdetails || []);
    setParentRowData(null);
  };

  /* Handle Submit */
  const handleSave = () => {
    // Prepare the data structure expected by parent
    const extensionData = {
      ...parentRowData, // Keep parent row data
      extensionItemsdetails: tableData, // Add the extensions array
    };

    // Pass the data back to parent component
    if (props.onSave) {
      props.onSave(extensionData);
    }
    handleCancel();
  };

  // Define table columns
  const columns = [
    {
      name: "Extension",
      selector: (row) => row.extensionCount,
      sortable: true,
      width: "120px",
    },
    {
      name: "From Date",
      selector: (row) => row.extensionfromDate,
      sortable: true,
      width: "120px",
    },
    {
      name: "To Date",
      selector: (row) => row.extensiontoDate,
      sortable: true,
      width: "120px",
    },
    {
      name: "Days",
      selector: (row) => row.extendedDays,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: "Rent/Day",
      selector: (row) => `₹${row.rentPerDay}`,
      sortable: true,
      width: "120px",
    },
    {
      name: "Total Rent",
      selector: (row) => `₹${row.rentValue}`,
      sortable: true,
      width: "120px",
    },
    {
      name: "Remarks",
      selector: (row) => row.extensionRemarks || "-",
      wrap: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => deleteRow(row.id)}
          title="Delete"
        >
          <i className="bi bi-trash"></i>
        </button>
      ),
      width: "80px",
      center: true,
    },
  ];

  // Calculate totals
  const calculateTotals = () => {
    const totalDays = tableData.reduce(
      (sum, item) => sum + parseInt(item.extendedDays || 0),
      0,
    );
    const totalRent = tableData.reduce(
      (sum, item) => sum + parseFloat(item.rentValue || 0),
      0,
    );
    return { totalDays, totalRent };
  };

  const { totalDays, totalRent } = calculateTotals();

  // Handle escape key
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
    // eslint-disable-next-line
  }, [props]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Extensions - {parentRowData?.itemName || "Item"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Parent Item Info */}
        {/*    {parentRowData && (
          <div className="alert alert-info mb-3">
            <Row>
              <Col md={4}>
                <strong>Item:</strong> {parentRowData.itemName || "N/A"}
              </Col>
              <Col md={4}>
                <strong>Original Rent/Day:</strong> ₹{parentRowData.pricePerDay || "0.00"}
              </Col>
              <Col md={4}>
                <strong>Existing Extensions:</strong> {tableData.length}
              </Col>
            </Row>
          </div>
        )} */}

        {/* Basic Details - For adding new extensions */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} className="text-center logoBtn">
                  <span className="iconLogo">AE</span>
                </Col>
                <Col xs={8}>
                  <span className="headerTitle">Add New Extension</span>
                  <span className="subHeaderTitle">
                    Extension {formInputs.extensionCount}
                  </span>
                </Col>
                <Col xs={2}>
                  <div className="d-flex justify-content-end p-2 me-3">
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={addExtensionToTable}
                      disabled={
                        !formInputs.extensionfromDate ||
                        !formInputs.extensiontoDate ||
                        !formInputs.rentPerDay
                      }
                    >
                      <i className="bi bi-plus"></i> Add
                    </button>
                  </div>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Extension"
                      type="text"
                      name="extensionCount"
                      placeholder=""
                      value={formInputs?.extensionCount}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Rent Per Day (₹)"
                      name="rentPerDay"
                      type="number"
                      placeholder="Enter rent per day"
                      value={formInputs?.rentPerDay}
                      onChange={onInputChange}
                      required
                      min="0"
                      step="0.01"
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="From Date"
                      name="extensionfromDate"
                      type="date"
                      placeholder=""
                      value={formInputs?.extensionfromDate}
                      onChange={onInputChange}
                      required
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="To Date"
                      name="extensiontoDate"
                      type="date"
                      placeholder=""
                      value={formInputs?.extensiontoDate}
                      onChange={onInputChange}
                      required
                      min={formInputs.extensionfromDate}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Extended Days"
                      name="extendedDays"
                      type="text"
                      placeholder=""
                      value={formInputs?.extendedDays}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={3}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Rent Value (₹)"
                      name="rentValue"
                      type="text"
                      placeholder=""
                      value={
                        formInputs?.rentValue ? `₹${formInputs.rentValue}` : ""
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={6}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Remarks"
                      name="extensionRemarks"
                      type="text"
                      placeholder="Enter remarks (optional)"
                      value={formInputs?.extensionRemarks}
                      onChange={onInputChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Extension Details - Table showing all extensions */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility4}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ED</span>
                </Col>
                <Col xs={4} md={8} lg={4}>
                  <span className="headerTitle">All Extensions</span>
                  <span className="subHeaderTitle">
                    Total: {totalDays} days, ₹{totalRent.toFixed(2)}
                  </span>
                </Col>
                <Col xs={12} md={8} lg={8} className="headerButtonAlign"></Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible4 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      columns={columns}
                      data={tableData}
                      paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      highlightOnHover
                      noDataComponent={
                        <div className="p-3 text-center text-muted">
                          No extensions added yet. Use the form above to add
                          extensions.
                        </div>
                      }
                      conditionalRowStyles={[
                        {
                          when: (row) => true,
                          style: {
                            backgroundColor: "#f8f9fa",
                            "&:hover": {
                              backgroundColor: "#e9ecef",
                            },
                          },
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <Row className="my-4">
          <Col
            lg={{ span: 2, offset: 8 }}
            className="d-flex justify-content-end mt-2"
          >
            <button className="btn btn-danger me-2" onClick={handleCancel}>
              <i class="bi bi-x-circle mx-2"></i>
              Cancel
            </button>
          </Col>
          <Col lg={2} className="d-flex justify-content-center mt-2">
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={tableData.length === 0}
            >
              <i class="bi bi-arrow-return-right mx-2"></i>
              Submit
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default ErfExtenssionModal;
